import i18n from 'services/base/i18n';

export default {
  address: () => i18n.pgettext('Components|List History|Filter History|Site Input|Address Input', 'Enter IP Address'),
};
